import { render, staticRenderFns } from "./TradeRequestList.vue?vue&type=template&id=e3de43b2"
import script from "./TradeRequestList.vue?vue&type=script&lang=js"
export * from "./TradeRequestList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports